export default __webpack_public_path__ + "static/media/photo--lg--wheel-11.275fda9c.jpg";